import { Box, Typography } from '@mui/material'
import RequiredLabel from './RequiredLabel'
import styled from '@emotion/styled'
import InfoTooltip from './InfoTooltip'
import { Icon } from 'packages/eid-icons'

const RootBox = styled(Box)({
    background: '#fbfbfd',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.6rem',
})

const Header = styled(Box)(({ hideShadow, isVertical }) => ({
    gap: '3.5rem',
    display: isVertical ? 'block' : 'flex',
    position: 'relative',
    padding: '1.25rem 3rem 1.5rem',
    // padding: '0 10px 16px 20px',

    background: '#fbfbfd',

    ...(!hideShadow && {
        '&::after': {
            content: '""',
            position: 'absolute',
            inset: 'auto 0 -1.6rem 0',
            zIndex: 1,
            height: '1.6rem',
            background:
                'linear-gradient(180deg, rgba(0,0,0,0.05), rgba(0,0,0,0))',
        },
    }),
}))

const TitleWrapper = styled(Box)({
    width: '23.2rem',
})

const TitleContainer = styled(Box)({
    display: 'inline-flex',
    alignItems: 'flex-start',
    '& h3': {
        fontSize: '1.6rem',
        fontWeight: '600',
        color: '#1b1f1f',
        marginRight: '0.4rem',
        minWidth: 'max-content',
    },
})

const ItemWrapper = ({
    title,
    headerStyle,
    isRequired,
    childStyle,
    children,
    hideShadow = true,
    tooltipMessage,
    isVertical = false,
    titleStyle,
}) => {
    return (
        <RootBox>
            <Box>
                <Header
                    sx={headerStyle}
                    hideShadow={hideShadow}
                    isVertical={isVertical}
                >
                    <Box>
                        <TitleWrapper sx={titleStyle}>
                            <TitleContainer>
                                <Typography variant="h3">{title}</Typography>
                                <InfoTooltip
                                    message={tooltipMessage}
                                    properties={[]}
                                    IconComponent={<Icon name="InfoNew" />}
                                    iconHoverColor={'#0057A0'}
                                />
                            </TitleContainer>
                        </TitleWrapper>
                        {isRequired && <RequiredLabel />}
                    </Box>
                    <Box sx={childStyle}>{children}</Box>
                </Header>
            </Box>
        </RootBox>
    )
}

export default ItemWrapper
